enum Platforms {
  FULLSCRIPT = "Fullscript",
  EMERSON = "Emerson",

  // Migration platforms
  WELLEVATE = "Wellevate",
}

export { Platforms };
